import { IElementoSlider, ImagenSlider } from '@appNeo/pages/plugins/slider/slider.component';

export const IMGSLIDER: IElementoSlider[] = [
  { media: { src: 'assets/images/inicio/hero.jpg', alt: '' }, titulo: 'Bienvenido a la mejor fiesta de tu vida'}
];

export const IMGCAROUSEL: IElementoSlider[] = [
  { media: { src: 'https://picsum.photos/id/238/505/354', alt: 'img1' } },
  { media: { src: 'https://picsum.photos/id/241/505/354', alt: 'img2' } },
  { media: { src: 'https://picsum.photos/id/239/505/354', alt: 'img3' } },
  { media: { src: 'https://picsum.photos/id/238/505/354', alt: 'img4' } },
  { media: { src: 'https://picsum.photos/id/242/505/354', alt: 'img5' } },
  { media: { src: 'https://picsum.photos/id/244/505/354', alt: 'img6' } },
  { media: { src: 'https://picsum.photos/id/244/505/354', alt: 'img7' } }
];

